<template>
  <div>
    <router-view v-if="!isLoading" />
    <loading-page v-else :isFullPage="true" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import LoadingPage from '../../paymentLink/components/LoadingPage.vue';

export default {
  name: 'v2-onboarding-wrapper',
  components: {
    LoadingPage,
  },
  computed: {
    ...mapState('auth', ['token']),
    ...mapState('onboardingV2', [
      'paymentLink',
      'isLoading',
      'nextRoute',
      'onboarding',
      'extraQueryRoute',
    ]),
    ...mapState('paymentLink', ['paymentLink']),
  },
  methods: {
    ...mapActions('auth', ['setToken']),
    ...mapActions('onboardingV2', ['getOnboarding', 'setLoading', 'startListeningLandscape']),
  },
  async mounted() {
    this.setLoading({ loading: true });

    if (!this.paymentLink) {
      await this.$router.replace({
        name: 'payment-link-wrapper',
        query: {
          ...this.$route.query,
          ...this.extraQueryRoute,
        },
      });
      return;
    }

    this.startListeningLandscape();

    const {
      transactionId,
      onboardingToken,
    } = this.$route.query;

    await this.setToken({ token: onboardingToken });
    await this.getOnboarding({ transactionId });

    await this.$router.replace({
      name: this.nextRoute,
      query: {
        ...this.$route.query,
        ...this.extraQueryRoute,
      },
    });

    this.setLoading({ loading: false });
  },
};
</script>
